<div class="root">
  <div>
    <h2 class="fs-5" i18n>IP address</h2>

    <p i18n>PeerTube thinks your web browser public IP is <strong>{{ debug?.ip }}</strong>.</p>

    <p i18n>If this is not your correct public IP, please consider fixing it because:</p>
    <ul>
      <li i18n>Views may not be counted correctly (reduced compared to what they should be)</li>
      <li i18n>Anti brute force system could be overzealous</li>
      <li i18n>P2P system could not work correctly</li>
    </ul>

    <p i18n>To fix it:<p>
    <ul>
      <li i18n>Check the <code>trust_proxy</code> configuration key</li>
    </ul>
  </div>

  <div class="mt-4" [hidden]="isEmailDisabled()">
    <h2 class="fs-5" i18n>Emails</h2>

    <form (ngSubmit)="sendTestEmails()">
      <div class="form-group">
        <label i18n for="fromName">Send test emails to this address</label>
        <div i18n class="form-group-description">PeerTube can send all available email templates to the following email address</div>
        <input [(ngModel)]="testEmail" type="email" id="test-email" name="test-email" class="form-control">
      </div>

      <input type="submit" i18n-value value="Send test emails" class="peertube-button primary-button" [disabled]="!testEmail" />
    </form>
  </div>
</div>
